import scrollTo from '../scroll/handle-scroll-to';

const scrollToTopOnChangePage = () => {
  $(document).on('click', '.boost-pfs-filter-bottom-pagination a', function(event) {
    event.stopPropagation();

    scrollTo(0);
  });
}

scrollToTopOnChangePage();
